import React, { useState } from "react";
import styles from "./contactTeams.module.scss";
import { Tooltip} from 'antd';
import { useSelector } from "react-redux";
import { contacts, initialStateModel, LoginState } from "../../../../models/model";
import { useHistory } from "react-router-dom";
import { SocketChatService } from "../../../../base/socketChatService";
import { toastInformation } from "../../../../base/callService/common";
import ProfileAvatarGroup from "../../../chat/leftsidebar/profileavatargroup";
import { URInput } from "../../../../shared/widgets/input";
import { initiateCall, sendDirectVideoCallRequest, sendVideoCallRequest } from "../../../../base/callService/callService";
import { generateChatID, userInfo } from "../../../../base/socketChatService/utils";
import { contactService } from "../../../../base/contactService";
import NoContent from "../../../../shared/widgets/noContent";
import noResult from "../../../../styles/images/contactcenterEmpty.svg"


export default function ContactTeamsSingle (){

  const contactList: contacts = useSelector((state: initialStateModel) => state.contactReducer);
  const loginDetails: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
  const allReducer: initialStateModel = useSelector((state: initialStateModel) => state);
  let { contactWindowDetails } = allReducer.contactWindowReducer;
  const [membersList, setMembersList] = useState([]);
  const [status, setStatus] = useState(false);

  let history = useHistory();

  const userDetails = loginDetails.userdetails;
  const searchMember =(e:any)=>{
    if(e.target.value.trim() !== 0){
    let input: any = e.target.value.toLowerCase();
    const filterParticipant:any = contactWindowDetails?.teammembersdetails.filter((value: any) => value?.caller_id?.toLowerCase().includes(input));
     setMembersList(filterParticipant); 
     setStatus(true)
    }
  }


  const OpenChatWindow = (input:any) => {
    const userDetails = userInfo();
    const socketChat = new SocketChatService(userDetails.fromID, userDetails.domainId);
    let chatDetail ={chatId:generateChatID(userInfo().fromID, input?.sip_login_id?.toString())};
    
    if(input?.sip_login_id !== loginDetails.userdetails?.sip_login_id){
      socketChat.openChatWindow(input,history,chatDetail);
    }
 }

 const openContactWindow =(data: any)=>{
  if(data?.sip_login_id!==userDetails.sip_login_id){
    contactService.openContactWindow(data,0); 
    contactService.scrollContactWindow(data, 0)
  }
 }


 const makeAudioCall = (data: any) => {
    if (data?.ext) { initiateCall(data.ext, 'audio'); }
    else {
      toastInformation("Future Implementation");
    }
};

  const makeVideo = (data: any) => {
    if (data?.ext) {
    sendDirectVideoCallRequest(data);  
    } else {
      toastInformation("Future Implementation");
    }
  };

  var len = Array.isArray(contactList?.teamContacs) && contactList?.teamContacs.length > 7 ? Math.ceil((contactList?.teamContacs?.length / 8)) : 1;
  var random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();

   const count = contactWindowDetails?.teammembersdetails.filter((elem: any)=>{
    if(Object.keys(elem).length !== 0){
      return true;
    }
    return false;
  })


  return (
    <>
      <div className={styles.favSec}>


            <div className={styles.rightbartop}>
            <div className={styles.memStyle}>Members ({count.length})</div>
            <div className={styles.rights}>
                  {/* <URInput placeHolder="Search" className={styles.rightbarsearch} onChange={searchTaskinList} /> */}
              <URInput placeHolder="Search" className={`customFocused ${styles.rightbarsearch}`} onChange={searchMember}/>
            </div>
        </div>
        
     {(status && membersList.length ===0) ?  <NoContent image={noResult}
              title={'No Result found'}
              description={''} />:

        <div className={`${"scroller"} ${styles.mainscroll} ${contactList?.favContacts?.length >0? '' : styles.nofavscroll}`}>     
          { (status ? membersList : contactWindowDetails?.teammembersdetails).map((list:any,index:any)=>{
          return(
            <>
            
            {list?.caller_id&&
             <div className={styles.confavmain}>
            <div className={styles.favList} key={list?.caller_id} onClick={()=>openContactWindow(list)}>
            <div className={styles.teamIcon}>
                <ProfileAvatarGroup contactDetail={list} profileSize={28} randomColor={random_color[index]} plusContent={1}></ProfileAvatarGroup>
             </div>
           <div className={styles.teamName}>
               { list?.sip_login_id === userDetails?.sip_login_id ?
                     <div className={styles.name} >
                    <span>
                      {list?.sip_login_id === userDetails?.sip_login_id && "You"}
                    </span>
                    { contactWindowDetails?.admin_members?.includes(list?.sip_login_id)? " (Admin)" : ""}
                    </div>:
                    <div className={styles.name}>
                    <span>
                      {list?.sip_login_id !== userDetails?.sip_login_id && list?.caller_id}
                    </span>
                    { contactWindowDetails.admin_members?.includes(list?.sip_login_id)? " (Admin)" : ""}
                    </div>}           
            </div>           
           
            </div>
            {(list.sip_login_id !== userDetails.sip_login_id)?
           <div className={styles.hoverdiv}>
              <ul>
                <li><Tooltip placement="top" title="Call">
                  <span className={styles.iconCall} onClick={()=>makeAudioCall(list)}
                  ></span></Tooltip></li>
                <li><Tooltip placement="top" title="Chat">
                  <span className={styles.iconChat}  onClick={()=>OpenChatWindow(list)}></span>
                </Tooltip></li>
                <li><Tooltip placement="top" title="Meet">
                  <span className={styles.iconMeet} onClick={()=>makeVideo(list)}></span></Tooltip></li>
              </ul>
            </div>:null}
             </div>}
            </>
          );
          }
            )}
          
        </div> 
       }
      </div>
    </>
  );
}      



